import React from 'react';
import LaboratoryResearchDetails from './Components/LaboratoryResearchDetails';

const LaboratoryResearchDetailsPage = () => {
  return (
    <div className="w-full h-full">
      <div className="pb-1">
        <LaboratoryResearchDetails />
      </div>
    </div>
  );
};

export default LaboratoryResearchDetailsPage;
